import Icon from 'snippets/icon/icon'
import PreactImage from '@/components/snippets/image/image'
const GreenTick = () => (
  <div className="absolute my-auto rounded-full -left-1 -top-1 h-fit w-fit bg-secondary-green md:left-0 md:top-0">
    <Icon id="tick" className="min-h-6 min-w-6 text-primary-white" />
  </div>
)

const parseIconSize = (iconSize) => {
  if (iconSize === 'big') return 'max-h-16 w-24 max-w-24 md:max-h-28 md:max-w-28'
  return 'w-24 max-w-24'
}

export const AvatarSelectOptionsInput = ({ label, name, value, required, onChange, options, className, iconSize }) => {
  return (
    <div className={'flex w-full flex-col gap-2 overflow-y-hidden overflow-x-auto'}>
      <div className={className || 'grid grid-cols-5'}>
        {options?.map((option) => {
          const selectedOption = option.value?.toString() === value?.toString()
          return (
            <div key={option.value} class={parseIconSize(iconSize)}>
              <div
                className={`relative aspect-1 w-24 rounded-full border border-solid  bg-transparent transition-colors
        ${selectedOption ? 'border-3 border-primary-black' : 'border-none'}`}
              >
                <div className={'h-11/12 absolute inset-0 m-auto aspect-1 min-h-12 w-11/12  '}>
                  <div
                    className={`m-auto flex h-full flex-row justify-between p-2 transition-opacity  ${
                      selectedOption ? 'opacity-100' : 'opacity-50'
                    }`}
                  >
                    <PreactImage
                      imageClass="fit object-bottom"
                      className={'h-full w-full object-cover'}
                      key={'id'}
                      imageUrl={[option.avatarUrl]}
                    />
                  </div>
                  <input
                    onChange={onChange}
                    value={option.value}
                    data-custom-type="input"
                    name={name}
                    checked={!!selectedOption}
                    type="checkbox"
                    className={'absolute inset-0 z-10 h-full w-full cursor-pointer appearance-none opacity-0 '}
                  />
                  {!!selectedOption && <GreenTick />}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
